/* eslint-disable import/prefer-default-export */
import { getRoot } from 'mobx-state-tree';
import { intersection } from 'lodash-es';
// import { IRootModel } from './RootModel';
export const checkAccess = (self) => {
    // @TODO uses exact same logic as amplify/function/trackProgress.checkAccess
    // consolidate to one place
    // anyone can access the item
    if (self.accessConfiguration === 'anonymous') {
        return true;
    }
    // only logged in users can access the item
    const rootModel = getRoot(self); // as IRootModel;
    if (self.accessConfiguration === 'loggedIn' && !rootModel.isAnonymous) {
        return true;
    }
    // use access groups - this is also default behavior
    const access = rootModel.currentAccess;
    // console.log(
    //   `checking access for ${self.name}`,
    //   {
    //     courseAccessGroups: self.courseAccessGroups,
    //     excludeFromAllCourses: self.excludeFromAllCourses,
    //     customerAccess: access,
    //   },
    // );
    if (!access) {
        return false;
    }
    if (access.purchasedCourses?.indexOf(self.id) >= 0) {
        // console.log('Granted access to purchased course', self.id);
        return true;
    }
    const { excludeFromAllCourses, accessGroups: courseAccessGroups } = self;
    const customerAccessGroups = access.groups || [];
    if (!excludeFromAllCourses && customerAccessGroups.includes('ALL_COURSES')) {
        // console.log('Access granted via ALL_COURSES group');
        return true;
    }
    const commonGroups = intersection(courseAccessGroups, customerAccessGroups);
    if (commonGroups.length > 0) {
        console.log('Access granted via accessGroups: ', commonGroups);
        return true;
    }
    if (access.purchasedCourses.indexOf(`,${self.id},`) >= 0) {
        console.log('Access granted via purchasedCourses');
        return true;
    }
    return false;
};
export const slugify = (title) => (title
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, '') // Remove invalid characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
);
//# sourceMappingURL=itemCommon.js.map